import React from 'react';
import PersonalInfo from './PersonalInfo';
import GettingToKnowYou from './GettingToKnowYou';
import { Col, Row, Container } from 'react-bootstrap';
import IdentityVerification from './IdentityVerification';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import PropTypes from 'prop-types';
import BackNext from '../../Common/SubComponents/BackNext';

export default function InsuredInfo(props) {
    const { onMultiFieldChange, fullFormState, onFieldChange, postConsumerApplication, onNext } = props;

    const formMethods = useForm({
        resolver: yupResolver(InsuredInfo.ValidationSchema()),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: { ...fullFormState.steps.personalInfo, ...fullFormState.steps.gettingToKnowYou, ...fullFormState.steps.identityVerification },
    });

    const { register, handleSubmit, setValue, trigger } = formMethods;
    return (
        <Container>
            <FormProvider {...formMethods}>
                <form className="quote-form" onSubmit={handleSubmit(onNext)}>
                    <Row className="formPage justify-content-center">
                        <Col lg={6}>
                            <PersonalInfo
                                formState={fullFormState.steps.personalInfo}
                                basicInfo={fullFormState.steps.basicInfo}
                                onFieldChange={(field, value) => onFieldChange('personalInfo', field, value)}
                                trigger={trigger}
                                onFormComplete={() => postConsumerApplication()}
                            />
                            <GettingToKnowYou
                                formState={fullFormState.steps.gettingToKnowYou}
                                basicInfo={fullFormState.steps.basicInfo}
                                onFieldChange={(field, value) => onFieldChange('gettingToKnowYou', field, value)}
                                onMultiFieldChange={onMultiFieldChange}
                                fullFormState={fullFormState}
                                register={register}
                                setValue={setValue}
                                trigger={trigger}
                            />
                            <IdentityVerification
                                formState={fullFormState.steps.identityVerification} basicInfo={fullFormState.steps.basicInfo}
                                onFieldChange={(field, value) => onFieldChange('identityVerification', field, value)}
                                register={register}
                                setValue={setValue}
                                trigger={trigger} />
                        </Col>
                    </Row>
                    <BackNext onBack={props.onBack} colSize={2} width={100} continueLabel={{ text: 'Next' }} />
                </form>
            </FormProvider>
        </Container>
    );
}

InsuredInfo.ValidationSchema = () => {
    return object().shape({ ...PersonalInfo.ValidationSchema.fields, ...GettingToKnowYou.ValidationSchema().fields, ...IdentityVerification.ValidationSchema.fields });
};

InsuredInfo.propTypes = {
    fullFormState: PropTypes.object,
    onFieldChange: PropTypes.func,
    onMultiFieldChange: PropTypes.func,
    onNext: PropTypes.func,
    onBack: PropTypes.func
};
